module.exports = __webpack_public_path__ + "img/circle4.dc962155.gif";